import { render, staticRenderFns } from "./MNotification.vue?vue&type=template&id=fa540a22"
import script from "./MNotification.vue?vue&type=script&lang=js"
export * from "./MNotification.vue?vue&type=script&lang=js"
import style0 from "./MNotification.vue?vue&type=style&index=0&id=fa540a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports